"use client";
import { useAuth0 } from "@auth0/auth0-react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function Home() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      router.replace("/dashboard");
    } else {
      const selectedLocale = localStorage.getItem("appLanguage") || "en";
      const locale = selectedLocale.split("-")[0];
      loginWithRedirect({
        authorizationParams: {
          redirect_uri: `${window.location.origin}`,
          ui_locales: locale,
        },
      });
    }
  }, [isAuthenticated, isLoading, router, loginWithRedirect]);

  return null;
}
